import { gqlQuery, gqlMutate } from '@hapana/shared/web/services/requests.service'
import {
  trialStatusQuery,
  onboardingProgressQuery,
  verifyCheckoutSessionQuery,
} from '_services/graphql/trial-management.queries'
import {
  completeOnboardingStepMutation,
  skipOnboardingStepMutation,
  createCheckoutSessionMutation,
  requestUpgradeMutation,
  createMemberPreviewSessionMutation,
} from '_services/graphql/trial-management.mutations'

export const TRIAL_STATUS_QUERY_KEY = 'TRIAL_STATUS'
export const ONBOARDING_PROGRESS_QUERY_KEY = 'ONBOARDING_PROGRESS'

export const getTrialStatus = gqlQuery({
  key: TRIAL_STATUS_QUERY_KEY,
  query: trialStatusQuery,
  options: {
    isV1: false,
  },
})

export const getOnboardingProgress = gqlQuery({
  key: ONBOARDING_PROGRESS_QUERY_KEY,
  query: onboardingProgressQuery,
  options: {
    isV1: false,
  },
})

export const completeOnboardingStepFn = (variables: {
  corporateId: string
  stepKey: string
  completedByUserId?: string
}) =>
  gqlMutate({
    mutation: completeOnboardingStepMutation,
    variables,
  })

export const skipOnboardingStepFn = (variables: { corporateId: string; stepKey: string }) =>
  gqlMutate({
    mutation: skipOnboardingStepMutation,
    variables,
  })

export const requestUpgradeFn = (variables: {
  corporateId: string
  requestedByName?: string
  requestedByEmail?: string
}) =>
  gqlMutate({
    mutation: requestUpgradeMutation,
    variables,
  })

export const CHECKOUT_SESSION_QUERY_KEY = 'VERIFY_CHECKOUT_SESSION'

export const createCheckoutSessionFn = (variables: {
  corporateId: string
  planId: string
  successUrl: string
  cancelUrl: string
}) =>
  gqlMutate({
    mutation: createCheckoutSessionMutation,
    variables,
  })

export const MEMBER_PREVIEW_SESSION_QUERY_KEY = 'MEMBER_PREVIEW_SESSION'

export const createMemberPreviewSessionFn = (variables: { corporateId: string }) =>
  gqlMutate({
    mutation: createMemberPreviewSessionMutation,
    variables,
  })

export const getVerifyCheckoutSession = gqlQuery({
  key: CHECKOUT_SESSION_QUERY_KEY,
  query: verifyCheckoutSessionQuery,
  options: {
    isV1: false,
  },
})
